import type { Platform } from './types';
import type { KeyValueStore } from './kvStore';
import { createDefaultPlatform, defaultKvStore } from './default';

/**
 * Access point for the platform adapter layer (ARCH-005, ADR-012).
 * Lazily instantiates the build's default platform on first use;
 * `setPlatform` exists for tests and alternate entry points.
 *
 * `getKvStore()` exposes the backend key-value store the persistence layer
 * (`storage` singleton / `BatchedStorageManager`, ARCH-002) does its I/O
 * through — chrome.storage.local on the extension, IndexedDB on the web.
 */

let instance: Platform | null = null;

export function getPlatform(): Platform {
  if (!instance) {
    instance = createDefaultPlatform();
  }
  return instance;
}

export function setPlatform(platform: Platform): void {
  instance = platform;
}

export function getKvStore(): KeyValueStore {
  return defaultKvStore;
}

export type { KeyValueStore } from './kvStore';
export type {
  MessageBus,
  MessageListener,
  Platform,
  PlatformActions,
  PlatformCapabilities,
  PlatformStorageChange,
  StorageAdapter,
  StorageChangeListener,
  StorageChangeMap,
  Unsubscribe,
} from './types';
